import { Component, input, Input, OnInit } from '@angular/core';
import { GameModel, GameStatisticsPlayerViewModel} from '../../../shared/models/GameModels';
import { compileComponentClassMetadata } from '@angular/compiler';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';

@Component({
    selector: 'app-game-header-small',
    imports: [CommonModule, MaterialModule],
    templateUrl: './game-header-small.component.html',
    styleUrls: ['./game-header-small.component.css']
})
export class GameHeaderSmallComponent implements OnInit {

  readonly Game = input<GameModel>();
  readonly Statistics = input<GameStatisticsPlayerViewModel[]>();
  constructor() { }

  ngOnInit() {
  }

}
